// Module
var code = "<input data-bind=\"checked: $parent.GetValue(Name), attr: { 'data-on-text': '&check;', 'data-off-text': 'X' }\" type=\"checkbox\" class=\"make-switch\" data-wrapper-class=\"custom-wrapper\">";
// Exports
export default code;